import { Editor, Plugin } from 'grapesjs';
import { mustacheFunction } from './functions';

const plugin: Plugin<{}> = (editor: Editor) => {
  const blockManager = editor.BlockManager;
  const domComponents = editor.DomComponents;

  blockManager.add('accounting-report-header', {
    label: 'Report Header',
    category: 'Accounting',
    content: [
      {
        type: 'accounting-report-header',
        attributes: { class: 'accounting-report-header fixed' },
        styles: `
          .accounting-report-header {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-bottom: 16px;
          }
          .company-name {
            font-size: 18px;
            color: #000;
            margin-bottom: 8px;
          }
          .report-title {
            font-size: 14px;
            color: #000;
            margin-bottom: 4px;
          }
          .report-date {
            font-weight: 300;
            font-size: 12px;
            color: #000;
          }
        `,
        components: [
          {
            type: 'div',
            attributes: { class: 'company-name' },
            components: [{ type: 'variable', variable: 'organization' }],
          },
          { type: 'text', content: 'Report Title', attributes: { class: 'report-title' } },
          {
            type: 'div',
            attributes: { class: 'report-date' },
            components: [{ type: 'variable', prefix: 'As of ', variable: 'reportDate' }],
          },
        ],
      },
    ],
  });

  const defaultIndent = 6;

  blockManager.add('report-accounts', {
    label: 'Report Accounts',
    category: 'Accounting',
    attributes: { class: 'wrap' },
    content: [
      {
        styles: `
          .group-title-row {
            font-size: 10px;
          }
          .group-indentation {
            padding-left: ${defaultIndent}px;
            font-size: 10px;
          }
          .subgroup-indentation {
            padding-left: ${defaultIndent * 2}px;
            font-size: 10px;
          }
          .account-line {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-size: 10px;
            color: #000;
            padding: 1.5px 0;
          }
          .account-name {
            flex: 1;
            padding-left: ${defaultIndent * 3}px;
          }
          .account-number {
            margin-right: 8px;
            color: #666;
            width: 60px;
          }
          .account-amount {
            text-align: right;
            width: 100px;
          }
          .double-line {
            border: 1px double #000;
            border-left-width: 0px;
            border-right-width: 0px;
            height: 3px;
            width: 100%;
          }
          .subtotal {
            font-weight: 500;
            border-top: 1px solid #F2F2F2;
          }
        `,
        components: [
          { type: 'div', attributes: { class: 'group-title-row' }, components: [{ type: 'text', content: 'ASSETS' }] },
          {
            type: 'div',
            attributes: { class: 'wrap' },
            components: [
              {
                type: 'div',
                attributes: { class: 'group-indentation' },
                components: [{ type: 'text', content: 'Current Assets' }],
              },
              {
                type: 'list',
                attributes: { class: 'wrap' },
                list: 'currentAssets.accounts.items',
                components: [
                  {
                    type: 'depth-indentation',
                    components: [
                      {
                        type: 'div',
                        attributes: { class: 'account-line' },
                        components: [
                          { type: 'variable', variable: 'accountName', attributes: { class: 'account-name' } },
                          {
                            type: 'hide-if-true',
                            variable: 'hasChildren',
                            components: [
                              {
                                type: 'hide-if-true',
                                variable: 'isZeroBalance',
                                components: [
                                  {
                                    type: 'div',
                                    attributes: { class: 'account-amount' },
                                    components: [{ type: 'variable', variable: 'balance' }],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                components: [
                  {
                    type: 'div',
                    attributes: { class: 'account-line subtotal' },
                    components: [
                      { type: 'text', attributes: { class: 'group-indentation' }, content: 'Total Current Assets' },
                      {
                        type: 'div',
                        attributes: { class: 'account-amount' },
                        components: [{ type: 'variable', variable: 'currentAssets.balanceFmt' }],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            components: [
              {
                type: 'div',
                attributes: { class: 'account-line subtotal' },
                components: [
                  { type: 'text', content: 'TOTAL ASSETS' },
                  {
                    type: 'div',
                    attributes: { class: 'account-amount' },
                    components: [{ type: 'variable', variable: 'totalAssets' }],
                  },
                ],
              },
              { type: 'div', attributes: { class: 'double-line' } },
            ],
          },
        ],
      },
    ],
  });

  blockManager.add('accounting-report-header-row', {
    label: 'Report Header Row',
    category: 'Accounting',
    content: [
      {
        styles: `
      .accounting-report-header-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 10px;
        color: #000;
        padding: 1.5px 0;
        border-top: 1px solid #000;
        border-bottom: 1px solid #000;
        margin-top: 8px;
      }
    `,
        components: [
          {
            type: 'div',
            attributes: { class: 'accounting-report-header-row' },
            components: [{ type: 'div' }, { type: 'text', content: 'TOTAL' }],
          },
        ],
      },
    ],
  });

  blockManager.add('accounting-report-footer', {
    label: 'Report Footer',
    category: 'Accounting',
    content: [
      {
        styles: `
          .accounting-report-footer {
            position: absolute;
            top: 770px;
            left: 0;
            right: 0;
            height: 15px;
            display: flex;
            flex-direction: column;
            align-items: center;
            font-size: 8px;
            color: #AFAFAF;
            width: 100%;
            font-weight: bold;
          }
          .accounting-report-page-number {
            position: absolute;
            top: 770px;
            height: 15px;
            display: flex;
            flex-direction: row;
            font-size: 8px;
            font-weight: bold;
            color: #AFAFAF;
            right: 20px;
          }

        `,
        type: 'div',
        attributes: { class: 'accounting-report-footer fixed' },
        components: [{ type: 'text', content: 'Accrual Basis  {{accrualBasis}}' }],
      },
      {
        type: 'div',
        attributes: { class: 'fixed accounting-report-page-number' },
        components: [
          { tagName: 'pagenumber', content: '#' },
          { type: 'text', content: '/' },
          { tagName: 'totalpages', content: '#' },
        ],
      },
    ],
  });

  domComponents.addType('depth-indentation', {
    model: {
      defaults: { tagName: 'div' },
      toHTML: function () {
        let childrenHtml = '';

        this.components().each((model) => {
          childrenHtml += model.toHTML();
        });

        const depthExpr = mustacheFunction('calc', { expr: `({{depth}} + 2) * ${defaultIndent}` }, '');

        return `<div {{#isSubtotal}}class="subtotal"{{/isSubtotal}} style="padding-left: ${depthExpr}px">${childrenHtml}</div>`;
      },
    },
  });

  domComponents.addType('account-line-item', {
    model: {
      defaults: {
        tagName: 'div',
        droppable: false,
        draggable: true,
        traits: [
          { type: 'text', label: 'Account Number', name: 'accountNumber', changeProp: true },
          { type: 'text', label: 'Account Name', name: 'accountName', changeProp: true },
          { type: 'text', label: 'Variable Name', name: 'variableName', changeProp: true },
        ],
      },
    },
  });
};

export default plugin;
